<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="goodsName">
        <span slot="label">
          <a-tooltip>商品名称<template slot="title">商品名称</template></a-tooltip>
        </span>
        <a-input v-model="form.goodsName" :maxLength="255" placeholder="请输入商品名称'"/>
      </a-form-model-item>
      <a-form-model-item prop="price">
        <span slot="label">
          <a-tooltip>商品价格<template slot="title">商品价格</template></a-tooltip>
        </span>
        <a-input v-model="form.price" placeholder="请输入商品价格'"/>
      </a-form-model-item>
      <a-form-model-item prop="unit">
        <span slot="label">
          <a-tooltip>包装单位<template slot="title">包装单位</template></a-tooltip>
        </span>
        <a-input v-model="form.unit" :maxLength="32" placeholder="请输入包装单位'"/>
      </a-form-model-item>
      <a-form-model-item prop="isHomeVisible">
        <span slot="label">
          <a-tooltip>是否首页展示<template slot="title">是否首页展示</template></a-tooltip>
        </span>
        <a-select placeholder="请输入是否首页展示" style="width: 100%" v-model="form.isHomeVisible" allowClear>
          <a-select-option v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="picture">
        <span slot="label">
          <a-tooltip>商品主图<template slot="title">商品主图</template></a-tooltip>
        </span>
        <a-upload
          name="img"
          listType="picture-card"
          class="avatar-uploader"
          :multiple="false"
          :show-upload-list="false"
          :preview="handlePreview"
          :before-upload="beforeOssUpload"
          :customRequest="coverImgUpload">
          <img
            v-if="form.picture"
            :src="form.picture"
            alt="picture"
            style="height: 140px; width: 140px;"/>
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <a-form-model-item prop="status">
        <span slot="label">
          <a-tooltip>商品状态<template slot="title">商品状态</template></a-tooltip>
        </span>
        <a-select placeholder="商品状态" style="width: 100%" v-model="form.status" allowClear>
          <a-select-option v-for="(item, index) in this.customDict.StatusEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="sort">
        <span slot="label">
          <a-tooltip>排序<template slot="title">排序</template></a-tooltip>
        </span>
        <a-input-number style="width: 100%" v-model="form.sort" :min="0" placeholder="请输入排序'"/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getGoodsExplosive, addGoodsExplosive, updateGoodsExplosive} from '@/api/goods/goodsExplosive'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {fileUpload} from "@/api/tool/common";
import {generateFilePath} from "@/api/tool/alioss";


export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        goodsName: null,
        price: null,
        unit: null,
        isHomeVisible: null,
        picture: null,
        status: 0,
        sort: null,
        createTime: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        goodsName: [{required: true, message: '商品名称' + '不能为空', trigger: 'blur'}],
        price: [{required: true, message: '商品价格' + '不能为空', trigger: 'blur'}],
        picture: [{required: true, message: '商品主图' + '不能为空', trigger: 'blur'}],
        sort: [{required: true, message: '排序' + '不能为空', trigger: 'blur'}]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        goodsName: null,
        price: null,
        unit: null,
        isHomeVisible: null,
        picture: null,
        status: 0,
        sort: null,
        createTime: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getGoodsExplosive({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    // oss 上传开始
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    coverImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'advert'
      const url = _this.uploadAliYunOss(uploadFile.name, prefix)
      /*_this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.form.masterImg = res
          _this.$message.success('上传成功')
        })
      })*/
      const formData = new FormData()
      formData.append('file', uploadFile, url)
      _this.$nextTick(() => {
        fileUpload(formData).then(res => {
          _this.form.picture = res.data.fullPath
          _this.$message.success('上传成功')
        })
      })
    },
    /**
     * 文件上传到oss返回url地址
     * @param { file } 文件对象
     */
    uploadAliYunOss(fileName, prefix) {
      // 获取文件后缀
      const suffix = fileName.substring(fileName.lastIndexOf('.'))
      // 生成文件名称
      const filePath = generateFilePath(prefix, suffix)
      return filePath
    },
    // oss 上传结束
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = '修改成功'
            updateGoodsExplosive(this.form).then(response => {
              this.$message.success(message, 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = '修改成功'
            addGoodsExplosive(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
